import Text from "./Text";

function Repeat() {
    return (
        <svg
            style={{ height: "inherit", width: "inherit" }}
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="loop-svg-current-color"
        >
            <path d="M14.5596 13.8154L14.3655 13.0335C13.7556 14.018 12.9137 14.8381 11.9135 15.4219C10.9132 16.0057 9.78511 16.3354 8.62791 16.3822C6.91171 16.3822 5.26581 15.7004 4.05227 14.4869C2.83874 13.2733 2.15698 11.6274 2.15698 9.91123H3.23547C3.23547 11.3414 3.8036 12.713 4.81488 13.7243C5.82616 14.7355 7.19775 15.3037 8.62791 15.3037C9.63021 15.2598 10.6055 14.9653 11.4646 14.4472C12.3238 13.929 13.0393 13.2038 13.5458 12.3378L12.532 12.6075L12.2732 11.529L14.4302 10.9897C14.5689 10.9555 14.7155 10.9777 14.8379 11.0516C14.9602 11.1254 15.0482 11.2447 15.0827 11.3834L15.6219 13.5403L14.5596 13.8154ZM2.69623 7.75426H2.82564L4.98262 7.21501L4.72378 6.13653L3.71 6.38997C4.21849 5.52698 4.93488 4.80498 5.79387 4.28977C6.65287 3.77456 7.62715 3.48253 8.62791 3.4403C10.0581 3.4403 11.4297 4.00844 12.4409 5.01971C13.4522 6.03099 14.0204 7.40258 14.0204 8.83275H15.0988C15.0988 7.11655 14.4171 5.47064 13.2035 4.25711C11.99 3.04357 10.3441 2.36182 8.62791 2.36182C7.46793 2.40598 6.33656 2.73446 5.33328 3.31837C4.33 3.90228 3.48555 4.72374 2.87418 5.71052L2.69623 4.92862L1.61774 5.18746L2.15698 7.34443C2.1865 7.46408 2.25612 7.57 2.35423 7.64457C2.45235 7.71914 2.57304 7.75785 2.69623 7.75426Z" />
        </svg>
    );
}

function LeftChevron() {
    return (
        <svg
            style={{ height: "18px", width: "10px", color: "inherit" }}
            width="10"
            height="18"
            viewBox="0 0 10 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="loop-svg-stroke-current-color"
        >
            <path
                d="M8.66266 16.4339L1.50603 9.27723L8.66266 2.12061"
                strokeWidth="2.38554"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function RightChevron() {
    return (
        <svg
            width="11"
            height="18"
            viewBox="0 0 11 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M2.00024 1.99998L9.15687 9.15661L2.00024 16.3132"
                stroke="black"
                strokeWidth="2.38554"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

function Tags(props: any) {
    return (
        <svg
            width="13"
            height="14"
            viewBox="0 0 13 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_189_534)">
                <path
                    d="M11.8138 0H7.47748C7.35316 0.0065 7.07041 0.200687 7.03385 0.23725L1.86229 5.408C1.54542 5.72487 1.54542 6.23837 1.86229 6.55525L2.50741 7.20038L1.86229 7.8455C1.54542 8.16238 1.54542 8.67587 1.86229 8.99275L5.63717 12.7676C5.7956 12.9261 6.00279 13.0049 6.21079 13.0049C6.41798 13.0049 6.62598 12.9261 6.78442 12.7676L11.9552 7.59606C11.9925 7.5595 12.1875 7.30925 12.1875 7.15325V0.403812C12.1989 0.177125 12.0364 0 11.8138 0ZM11.384 7.01594C11.3815 7.02 11.3799 7.02244 11.3807 7.02244L6.2116 12.194L2.43673 8.42075L3.08185 7.77562L5.63717 10.3309C5.7956 10.4894 6.00279 10.5682 6.21079 10.5682C6.41798 10.5682 6.62598 10.4894 6.78442 10.3309L11.384 5.73137V7.01594ZM11.384 3.25V4.57844C11.3815 4.5825 11.3799 4.58494 11.3807 4.58494L6.2116 9.7565L2.43673 5.98325L7.57335 0.847438C7.58879 0.836062 7.60748 0.823875 7.62616 0.8125H11.384V3.25ZM9.75898 2.028C9.75898 2.13574 9.80178 2.23908 9.87796 2.31526C9.95415 2.39145 10.0575 2.43425 10.1652 2.43425C10.273 2.43425 10.3763 2.39145 10.4525 2.31526C10.5287 2.23908 10.5715 2.13574 10.5715 2.028C10.5715 1.92026 10.5287 1.81692 10.4525 1.74074C10.3763 1.66455 10.273 1.62175 10.1652 1.62175C10.0575 1.62175 9.95415 1.66455 9.87796 1.74074C9.80178 1.81692 9.75898 1.92026 9.75898 2.028Z"
                    fill={props.color ? props.color : "black"}
                />
            </g>
            <defs>
                <clipPath id="clip0_189_534">
                    <rect width="13" height="13.0049" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}

function Cancel(props: any) {
    const _className = "loop-svg-current-color" + (props.className ? ` ${props.className}` : '');
    return (
        <svg
            width={props.width ? props.width : "13"}
            height={props.height ? props.height : "13"}
            viewBox="0 0 13 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={_className}
        >
            <path d="M7.21926 6.89327L11.9045 2.20783C11.9756 2.13914 12.0323 2.05699 12.0714 1.96615C12.1104 1.87531 12.1309 1.77761 12.1318 1.67875C12.1326 1.57989 12.1138 1.48185 12.0764 1.39035C12.0389 1.29885 11.9836 1.21571 11.9137 1.14581C11.8438 1.0759 11.7607 1.02061 11.6692 0.983178C11.5777 0.945742 11.4797 0.926903 11.3808 0.927762C11.2819 0.928622 11.1842 0.949161 11.0934 0.988182C11.0026 1.0272 10.9204 1.08392 10.8517 1.15504L6.16628 5.84029L1.48103 1.15504C1.34089 1.01797 1.15235 0.941707 0.956331 0.942787C0.760311 0.943866 0.572625 1.02221 0.434003 1.1608C0.295382 1.2994 0.21701 1.48707 0.215896 1.68309C0.214782 1.87911 0.291015 2.06766 0.428052 2.20783L5.11349 6.89327L0.428052 11.5787C0.35765 11.6476 0.301607 11.7297 0.263167 11.8204C0.224727 11.911 0.204655 12.0084 0.204113 12.1069C0.203571 12.2054 0.222569 12.303 0.260008 12.3941C0.297446 12.4851 0.352581 12.5679 0.422221 12.6375C0.491861 12.7071 0.574621 12.7623 0.66571 12.7997C0.756799 12.8371 0.854406 12.8561 0.952881 12.8555C1.05136 12.855 1.14874 12.8349 1.2394 12.7964C1.33006 12.758 1.41219 12.7019 1.48103 12.6315L6.16628 7.94624L10.8517 12.6315C10.9971 12.7769 11.1877 12.8496 11.3781 12.8496C11.5685 12.8496 11.7593 12.7769 11.9045 12.6315C12.0441 12.4919 12.1225 12.3025 12.1225 12.1051C12.1225 11.9077 12.0441 11.7183 11.9045 11.5787L7.21926 6.89327Z" />
        </svg>
    );
}

function Plus(props: any) {
    return (
        <svg
            width="13"
            height="13"
            viewBox="0 0 9 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0.5 5H4V8.5C4 8.63261 4.05268 8.75979 4.14645 8.85355C4.24021 8.94732 4.36739 9 4.5 9C4.63261 9 4.75979 8.94732 4.85355 8.85355C4.94732 8.75979 5 8.63261 5 8.5V5H8.5C8.63261 5 8.75979 4.94732 8.85355 4.85355C8.94732 4.75979 9 4.63261 9 4.5C9 4.36739 8.94732 4.24021 8.85355 4.14645C8.75979 4.05268 8.63261 4 8.5 4H5V0.5C5 0.367392 4.94732 0.240215 4.85355 0.146447C4.75979 0.0526785 4.63261 0 4.5 0C4.36739 0 4.24021 0.0526785 4.14645 0.146447C4.05268 0.240215 4 0.367392 4 0.5V4H0.5C0.367392 4 0.240215 4.05268 0.146447 4.14645C0.0526785 4.24021 0 4.36739 0 4.5C0 4.63261 0.0526785 4.75979 0.146447 4.85355C0.240215 4.94732 0.367392 5 0.5 5Z"
                fill={props.color ? props.color : "black"}
            />
        </svg>
    );
}

function PlusSmall(props: any) {
    return (
        <svg
            width="12"
            height="12"
            style={{ height: "12px", width: "12px" }}
            viewBox="0 0 9 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M0.5 5H4V8.5C4 8.63261 4.05268 8.75979 4.14645 8.85355C4.24021 8.94732 4.36739 9 4.5 9C4.63261 9 4.75979 8.94732 4.85355 8.85355C4.94732 8.75979 5 8.63261 5 8.5V5H8.5C8.63261 5 8.75979 4.94732 8.85355 4.85355C8.94732 4.75979 9 4.63261 9 4.5C9 4.36739 8.94732 4.24021 8.85355 4.14645C8.75979 4.05268 8.63261 4 8.5 4H5V0.5C5 0.367392 4.94732 0.240215 4.85355 0.146447C4.75979 0.0526785 4.63261 0 4.5 0C4.36739 0 4.24021 0.0526785 4.14645 0.146447C4.05268 0.240215 4 0.367392 4 0.5V4H0.5C0.367392 4 0.240215 4.05268 0.146447 4.14645C0.0526785 4.24021 0 4.36739 0 4.5C0 4.63261 0.0526785 4.75979 0.146447 4.85355C0.240215 4.94732 0.367392 5 0.5 5Z"
                fill={props.color ? props.color : "black"}
            />
        </svg>
    );
}

function Minus() {
    return (
        <svg
            width="14"
            height="2"
            viewBox="0 0 14 2"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M13.125 1.75H0.875C0.642936 1.75 0.420376 1.65781 0.256282 1.49372C0.0921874 1.32962 0 1.10706 0 0.875C0 0.642936 0.0921874 0.420376 0.256282 0.256282C0.420376 0.0921874 0.642936 0 0.875 0H13.125C13.3571 0 13.5796 0.0921874 13.7437 0.256282C13.9078 0.420376 14 0.642936 14 0.875C14 1.10706 13.9078 1.32962 13.7437 1.49372C13.5796 1.65781 13.3571 1.75 13.125 1.75Z"
                fill="black"
            />
        </svg>
    );
}

function Spinner(props: any) {
    return (
        <svg
            className={
                "loop-spinner-default" +
                (props.size ? " loop-spinner-size-" + props.size : "")
            }
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12,2.5A9.5,9.5,0,0,1,21.5,12a1,1,0,0,0,2-0.15A11.5,11.5,0,0,0,0.5,11.85a1,1,0,0,0,2,0.15A9.5,9.5,0,0,1,12,2.5Z"
                className="path"
                fill={props.color ? props.color : "#000"}
            />
        </svg>
    );
}

function Refresh(props: any) {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.56343 0.03125L0.435427 0.61525L1.95243 2.13325C0.919812 3.20628 0.256933 4.58108 0.0604273 6.05725C-0.141745 7.58439 0.166584 9.13552 0.937427 10.4692C1.70825 11.8029 2.89729 12.8452 4.32041 13.4347C5.74352 14.0243 7.32131 14.1281 8.80943 13.7302C10.2975 13.3311 11.6125 12.4524 12.5507 11.2303C13.489 10.0083 13.9982 8.51095 13.9994 6.97025C13.9984 5.42925 13.4894 3.93157 12.5511 2.70913C11.6129 1.48668 10.2978 0.607687 8.80943 0.20825L8.55243 1.17525C9.82837 1.51663 10.9559 2.26971 11.76 3.31756C12.5641 4.36541 12.9998 5.64942 12.9994 6.97025C13.0001 8.2909 12.5644 9.57478 11.7603 10.6224C10.9561 11.6699 9.82838 12.4226 8.55243 12.7632C7.27656 13.1059 5.92326 13.0177 4.70269 12.5123C3.48211 12.0069 2.46258 11.1126 1.80243 9.96825C1.15621 8.84694 0.890729 7.54643 1.04577 6.26156C1.20081 4.97669 1.76803 3.77665 2.66243 2.84125L3.97443 4.15325L4.11643 3.16325L4.56343 0.03125Z"
                fill={props.color ? props.color : "black"}
            />
        </svg>
    );
}

function Tick(props: any) {
    return (
        <svg
            width="19"
            height="14"
            viewBox="0 0 19 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.04474 13.3756C6.84305 13.5747 6.55809 13.7398 6.30761 13.7382C6.05713 13.7366 5.77439 13.5594 5.56697 13.3576L0.921787 8.65159L2.41764 7.17508L6.33286 11.1416L16.8211 0.714352L18.2724 2.23509L7.04474 13.3756V13.3756Z"
                fill={props.color ? props.color : "white"}
            />
        </svg>
    );
}

function InfoIcon(props: any) {
    return (
        <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10" cy="10" r="9" fill="#E0E0E0" />
            <text
                x="10"
                y="10"
                text-anchor="middle"
                alignment-baseline="middle"
                font-size="12"
                font-family="Arial, sans-serif"
                fill="black"
            >
                i
            </text>
        </svg>
    );
}

function Copy(props: any) {
    return (
        <svg
            width="15"
            height="20"
            viewBox="0 0 206 252"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <rect
                x="8"
                y="49"
                width="152"
                height="195"
                rx="12"
                stroke="black"
                stroke-width="20"
            />
            <path
                d="M68.5 8H186C192.627 8 198 13.3726 198 20V193"
                stroke="black"
                strokeWidth="20"
                strokeLinecap="round"
            />
        </svg>
    );
}

function Copied(props: any) {
    return (
        <svg
            width="15"
            height="20"
            viewBox="0 0 206 252"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M43 163.08L64.5 185L133 108"
                stroke="black"
                strokeWidth="20"
                strokeLinecap="round"
            />
            <rect
                x="8"
                y="49"
                width="152"
                height="195"
                rx="12"
                stroke="black"
                strokeWidth="20"
            />
            <path
                d="M68.5 8H186C192.627 8 198 13.3726 198 20V193"
                stroke="black"
                strokeWidth="20"
                strokeLinecap="round"
            />
        </svg>
    );
}

function TickCircle(props: any) {
    return (
        <svg
            width="25"
            height="25"
            viewBox="10 10 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={props.className ? props.className : ""}
        >
            <circle cx="25" cy="25" r="15" fill="#1C1C1C" />
            <path
                d="M17 25L22 30L33 19"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>

    )
}

function TickCircleFilledV2(props: any) {
    return (
        <svg style={props.style} className={props.classNames ? props.classNames : ""} xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none">
            <path d="M7.29417 12.9577L10.5048 16.1681L17.6729 9" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" />
        </svg>
    );
}

function TickCircleWithoutCircle({ number, ...props }) {
    return (
        <svg
            width="25"
            height="25"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={props.classNames ? props.classNames : ""}
        >
            {/* <circle cx="15" cy="15" r="14" fill="transparent" stroke="currentColor" strokeWidth="2" /> */}
            <text
                strokeWidth={2}
                x="50%" // Centers the text horizontally
                y="55%" // Centers the text vertically
                alignmentBaseline="middle" // Vertically centers the text relative to the y-coordinate
                textAnchor="middle" // Horizontally centers the text relative to the x-coordinate
                fontSize="24" // Adjust the font size if needed
                fill="currentColor" // Use currentColor for consistency with the circle's stroke color
            >
                {number}
            </text>
        </svg>
    );
}

function TickCircleWithNumber({ number, ...props }) {
    return (
        <svg style={props.style} className={props.classNames ? props.classNames : ""} xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" />
            <text
                strokeWidth={2}
                x="50%" // Centers the text horizontally
                y="55%" // Centers the text vertically
                alignmentBaseline="middle" // Vertically centers the text relative to the y-coordinate
                textAnchor="middle" // Horizontally centers the text relative to the x-coordinate
                fontSize="14" // Adjust the font size if needed
                fill="currentColor" // Use currentColor for consistency with the circle's stroke color
            >
                {number}
            </text>
        </svg>
    );
}

function Delete() {
    return (
        <svg fill="#000000" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
            width="15px" height="15px" viewBox="0 0 482.428 482.429">
            <g>
                <g>
                    <path d="M381.163,57.799h-75.094C302.323,25.316,274.686,0,241.214,0c-33.471,0-61.104,25.315-64.85,57.799h-75.098
			c-30.39,0-55.111,24.728-55.111,55.117v2.828c0,23.223,14.46,43.1,34.83,51.199v260.369c0,30.39,24.724,55.117,55.112,55.117
			h210.236c30.389,0,55.111-24.729,55.111-55.117V166.944c20.369-8.1,34.83-27.977,34.83-51.199v-2.828
			C436.274,82.527,411.551,57.799,381.163,57.799z M241.214,26.139c19.037,0,34.927,13.645,38.443,31.66h-76.879
			C206.293,39.783,222.184,26.139,241.214,26.139z M375.305,427.312c0,15.978-13,28.979-28.973,28.979H136.096
			c-15.973,0-28.973-13.002-28.973-28.979V170.861h268.182V427.312z M410.135,115.744c0,15.978-13,28.979-28.973,28.979H101.266
			c-15.973,0-28.973-13.001-28.973-28.979v-2.828c0-15.978,13-28.979,28.973-28.979h279.897c15.973,0,28.973,13.001,28.973,28.979
			V115.744z"/>
                    <path d="M171.144,422.863c7.218,0,13.069-5.853,13.069-13.068V262.641c0-7.216-5.852-13.07-13.069-13.07
			c-7.217,0-13.069,5.854-13.069,13.07v147.154C158.074,417.012,163.926,422.863,171.144,422.863z"/>
                    <path d="M241.214,422.863c7.218,0,13.07-5.853,13.07-13.068V262.641c0-7.216-5.854-13.07-13.07-13.07
			c-7.217,0-13.069,5.854-13.069,13.07v147.154C228.145,417.012,233.996,422.863,241.214,422.863z"/>
                    <path d="M311.284,422.863c7.217,0,13.068-5.853,13.068-13.068V262.641c0-7.216-5.852-13.07-13.068-13.07
			c-7.219,0-13.07,5.854-13.07,13.07v147.154C298.213,417.012,304.067,422.863,311.284,422.863z"/>
                </g>
            </g>
        </svg>
    )
}

function LeftNavigationIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="30" height="30">
            <path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}

function RightNavigationIcon() {
    return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="30" height="30">
            <path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}

function RightArrowIcon({height = "30", width = "30", classNames = ""}) {
    return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width={width} height={height} className={classNames}>
            <path d="M5 12h14M12 5l7 7-7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );
}

function DiscountBadge(props: any) {
    return (
        <div className="loop-cp-discount-badge">
            <Text.P1>{props.title}</Text.P1>
        </div>
    )
}

function Badge(props: any) {
    return (
        <div className={props.isPrimary ? "loop-cp-discount-badge-primary" : "loop-cp-discount-badge-backup"}>
            <Text.P2>{props.title}</Text.P2>
        </div>
    )
}

function FireIcon({
    height = "30",
    width = "30",
    classNames = "",
}) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="currentColor" className={"bi bi-fire " + classNames} viewBox="0 0 16 16">
            <path d="M8 16c3.314 0 6-2 6-5.5 0-1.5-.5-4-2.5-6 .25 1.5-1.25 2-1.25 2C11 4 9 .5 6 0c.357 2 .5 4-2 6-1.25 1-2 2.729-2 4.5C2 14 4.686 16 8 16m0-1c-1.657 0-3-1-3-2.75 0-.75.25-2 1.25-3C6.125 10 7 10.5 7 10.5c-.375-1.25.5-3.25 2-3.5-.179 1-.25 2 1 3 .625.5 1 1.364 1 2.25C11 14 9.657 15 8 15" />
        </svg>
    )
}
 
function DiscountPercentageIcon({
    height = "30",
    width = "30",
    classNames = "",
    ...props
}) {
    return (
        <svg style={props.style} className={classNames} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
            <path d="M3.9889 14.6604L2.46891 13.1404C1.84891 12.5204 1.84891 11.5004 2.46891 10.8804L3.9889 9.36039C4.2489 9.10039 4.4589 8.59038 4.4589 8.23038V6.08036C4.4589 5.20036 5.1789 4.48038 6.0589 4.48038H8.2089C8.5689 4.48038 9.0789 4.27041 9.3389 4.01041L10.8589 2.49039C11.4789 1.87039 12.4989 1.87039 13.1189 2.49039L14.6389 4.01041C14.8989 4.27041 15.4089 4.48038 15.7689 4.48038H17.9189C18.7989 4.48038 19.5189 5.20036 19.5189 6.08036V8.23038C19.5189 8.59038 19.7289 9.10039 19.9889 9.36039L21.5089 10.8804C22.1289 11.5004 22.1289 12.5204 21.5089 13.1404L19.9889 14.6604C19.7289 14.9204 19.5189 15.4304 19.5189 15.7904V17.9403C19.5189 18.8203 18.7989 19.5404 17.9189 19.5404H15.7689C15.4089 19.5404 14.8989 19.7504 14.6389 20.0104L13.1189 21.5304C12.4989 22.1504 11.4789 22.1504 10.8589 21.5304L9.3389 20.0104C9.0789 19.7504 8.5689 19.5404 8.2089 19.5404H6.0589C5.1789 19.5404 4.4589 18.8203 4.4589 17.9403V15.7904C4.4589 15.4204 4.2489 14.9104 3.9889 14.6604Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M9 15L15 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M14.4945 14.5H14.5035" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M9.49451 9.5H9.50349" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}

function GiftBox({
    height = "30",
    width = "30",
    classNames = "",
}) {
    return (
        <svg className={classNames} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 24" fill="none">
            <path d="M12 7V20M12 7H8.46429C7.94332 7 7.4437 6.78929 7.07533 6.41421C6.70695 6.03914 6.5 5.53043 6.5 5C6.5 4.46957 6.70695 3.96086 7.07533 3.58579C7.4437 3.21071 7.94332 3 8.46429 3C11.2143 3 12 7 12 7ZM12 7H15.5357C16.0567 7 16.5563 6.78929 16.9247 6.41421C17.293 6.03914 17.5 5.53043 17.5 5C17.5 4.46957 17.293 3.96086 16.9247 3.58579C16.5563 3.21071 16.0567 3 15.5357 3C12.7857 3 12 7 12 7ZM5 12H19V17.8C19 18.9201 19 19.4802 18.782 19.908C18.5903 20.2843 18.2843 20.5903 17.908 20.782C17.4802 21 16.9201 21 15.8 21H8.2C7.07989 21 6.51984 21 6.09202 20.782C5.71569 20.5903 5.40973 20.2843 5.21799 19.908C5 19.4802 5 18.9201 5 17.8V12ZM4.6 12H19.4C19.9601 12 20.2401 12 20.454 11.891C20.6422 11.7951 20.7951 11.6422 20.891 11.454C21 11.2401 21 10.9601 21 10.4V8.6C21 8.03995 21 7.75992 20.891 7.54601C20.7951 7.35785 20.6422 7.20487 20.454 7.10899C20.2401 7 19.9601 7 19.4 7H4.6C4.03995 7 3.75992 7 3.54601 7.10899C3.35785 7.20487 3.20487 7.35785 3.10899 7.54601C3 7.75992 3 8.03995 3 8.6V10.4C3 10.9601 3 11.2401 3.10899 11.454C3.20487 11.6422 3.35785 11.7951 3.54601 11.891C3.75992 12 4.03995 12 4.6 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}

function Warning({
    height = "16",
    width = "16",
    classNames = "",
}) {
    return (
        <svg className={classNames} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width={width} height={height}>
            <path fill-rule="evenodd" d="M10 0c-5.514 0-10 4.486-10 10s4.486 10 10 10 10-4.486 10-10-4.486-10-10-10zm-1 6a1 1 0 1 1 2 0v4a1 1 0 1 1-2 0v-4zm1 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
        </svg>
    )
}

export default Object.assign(
    {},
    {
        Repeat: Repeat,
        LeftChevron: LeftChevron,
        RightChevron: RightChevron,
        Tags: Tags,
        Cancel: Cancel,
        Plus: Plus,
        PlusSmall: PlusSmall,
        Minus: Minus,
        Spinner: Spinner,
        Refresh: Refresh,
        Tick: Tick,
        InfoIcon: InfoIcon,
        Copy: Copy,
        Copied: Copied,
        TickCircle: TickCircle,
        Delete: Delete,
        LeftNavigationIcon: LeftNavigationIcon,
        RightNavigationIcon: RightNavigationIcon,
        DiscountBadge: DiscountBadge,
        FireIcon: FireIcon,
        TickCircleWithNumber: TickCircleWithNumber,
        TickCircleWithoutCircle: TickCircleWithoutCircle,
        TickCircleFilledV2: TickCircleFilledV2,
        DiscountPercentageIcon: DiscountPercentageIcon,
        GiftBox: GiftBox,
        Warning: Warning,
        Badge: Badge,
        RightArrowIcon: RightArrowIcon,
    },
);
